import { ArrowForward } from "@mui/icons-material";
import { Button, Fab, Grid, Link } from "@mui/material";
import { Box } from "@mui/system";
import classes from "../Style/Home.scss"
import { useNavigate } from "react-router-dom";
import PageRoutes from "../Config/PageRoutes";
import { useState } from "react";
import CustomLink from "../Components/Common/CustomLink";


const Home = () => {
    const navigate = useNavigate();
    const [showFab1, setShowFab1] = useState(false);
    const [showFab2, setShowFab2] = useState(false);

    const handleClick = (route) => {
        navigate('../' + route, { replace: true });
    }

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={{ xs: 1, sm: 2, md: 6 }} justifyContent="center">
                <Grid item xs={12} sm={10} md={6} lg={5}>
                    <Box className="introBox introBox1" onMouseEnter={() => setShowFab1(true)} onMouseLeave={() => setShowFab1(false)}>
                        <span>Chapter one</span>
                        <h3>EU - Multiannual Control Programme (EU MACP)</h3>
                        <p>The aim of the EU MACP is to gather data on the occurrence and possible MRL exceedances of pesticide residues in food placed on the European market that are statistically representative enough to estimate the exposure of EU consumers to these residues.  The EU MACP is defined under <CustomLink href="https://www.google.com/url?q=https://eur-lex.europa.eu/legal-content/EN/TXT/?uri%3DCELEX%253A32019R0533%23:~:text%3DCommission%2520Implementing%2520Regulation%2520(EU)%25202019,of%2520plant%2520and%2520animal%2520origin&sa=D&source=docs&ust=1645465497469635&usg=AOvVaw3W6tVLBIaPfDuVHJpR5FlW" text='Regulation (EU) No 2019/533' />, which specifies combinations of pesticides (186 pesticides) and a minimum number of samples for 12 food products to be analysed by EU Member States. Chapter one gives a snapshot of this situation in 2020.</p>
                        {showFab1 &&
                            <Fab className="fabButton" onClick={() => { handleClick(PageRoutes.CHAPTER_ONE) }} sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
                                <ArrowForward />
                            </Fab>
                        }
                        <Box display='flex' justifyContent={'center'}>
                            <Button className='homeMobileButton' variant="outlined" sx={{ display: { xs: 'block', sm: 'block', md: 'none' } }} onClick={() => { handleClick(PageRoutes.CHAPTER_ONE) }}>Explore the Programme</Button>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={10} md={6} lg={5}>
                    <Box className="introBox introBox2" onMouseEnter={() => setShowFab2(true)} onMouseLeave={() => setShowFab2(false)}>
                        <span>Chapter two</span>
                        <h3>Multiannual National Control Programmes (MANCP)</h3>
                        <p>The MANCP are mainly risk-based sampling programmes that are complementary to the EU MACP. They focus on products likely to contain pesticide residues or for which MRL infringements have been identified in previous monitoring programmes. These programmes are not designed to provide statistically representative results for residues expected in food placed on the European market. The reporting countries define the priorities for their national control programmes considering the importance of food products for trade or national diets, the products with high residue prevalence or non-compliance rates in previous years, the use pattern of pesticides and laboratory capacities. The number of samples and/or the number of pesticides analysed by the participating countries is determined by the capacities of national control laboratories and available budget resources. Because they reflect the specific needs and priorities of the reporting countries, the results of national control programmes are not directly comparable. Chapter two gives a snapshot of this situation in 2020.</p>
                        {showFab2 &&
                            <Fab className="fabButton" onClick={() => { handleClick(PageRoutes.CHAPTER_TWO) }} sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
                                <ArrowForward />
                            </Fab>
                        }
                        <Box display='flex' justifyContent={'center'}>
                            <Button className='homeMobileButton' variant="outlined" sx={{ display: { xs: 'block', sm: 'block', md: 'none' } }} onClick={() => { handleClick(PageRoutes.CHAPTER_TWO) }}>Explore the Programme</Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box >
    );
}

export default Home;

